var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3434 4.92039C35.9655 2.28882 31.8704 0.534435 27.4007 0V6.83671C30.0122 7.27483 32.4264 8.2946 34.5057 9.75816L39.3434 4.92039Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.258 34.006C8.79444 31.9268 7.77479 29.5124 7.33667 26.9007H0.5C1.03455 31.3707 2.78881 35.4653 5.42048 38.8433L10.258 34.006Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50651 42.9616L14.3378 38.1304C16.4521 39.6535 18.9221 40.7143 21.5993 41.1633V48C17.0632 47.4575 12.9129 45.6588 9.50651 42.9616Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6305 13.8377L43.4616 9.00655C46.1588 12.4129 47.9575 16.5632 48.5 21.0993H41.6633C41.2142 18.422 40.1537 15.9518 38.6305 13.8377Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.0993C1.03845 16.5963 2.81489 12.4738 5.47926 9.08162L10.3136 13.9156C8.82029 16.0127 7.78034 18.455 7.33667 21.0993H0.5Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4007 41.1633C30.0451 40.7195 32.4872 39.6799 34.5842 38.1866L39.4185 43.0206C36.0263 45.6847 31.9037 47.4613 27.4007 48V41.1633Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6864 34.0844L43.5207 38.9184C46.1851 35.5262 47.9616 31.4037 48.5 26.9007H41.6633C41.2197 29.545 40.1797 31.9873 38.6864 34.0844Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58145 4.9794L14.4158 9.8134C16.5128 8.32009 18.9549 7.2805 21.5993 6.83671V0C17.0964 0.538684 12.9737 2.31526 9.58145 4.9794Z",
    fill: "#5CBF66",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircle);
export default __webpack_public_path__ + "static/media/iconCircle.e3102737c7c1128cec1e83ed96367581.svg";
export { ForwardRef as ReactComponent };